import { createAction, props } from '@ngrx/store';
import { HttpError } from '@virtual-trials-workspace/models';

export const createHttpErrorAction = (type: string) =>
  createAction(type, props<{ payload: HttpError }>());
